import { type FC } from 'react'
import { useIntl } from 'react-intl'
import { Typography } from '@mui/material'
import CardContent from '@mui/material/CardContent'
import { useTheme } from '@mui/material/styles'

import BasicCardButton, {
  type BasicCardButtonProps,
} from '@DS/components/components/foundations//shapes/card/basic/BasicCardButton'
import { svgLazyLoader } from '@Utils/icons'

import * as styles from './styles'

const AddFullIcon = svgLazyLoader('navigationAndAction/add_full')

type AutocompleteAddFavoriteProps = {
  elevation?: 'onSurface' | 'elevated'
  subtitle?: string
} & Omit<BasicCardButtonProps, 'elevation'>

const AutocompleteAddFavorite: FC<AutocompleteAddFavoriteProps> = ({
  elevation = 'onSurface',
  title,
  subtitle,
  ...rest
}) => {
  const theme = useTheme()
  const { formatMessage } = useIntl()

  return (
    <BasicCardButton
      {...rest}
      cardActionAreaProps={{ css: styles.basicCardButton(theme) }}
      background={elevation === 'elevated' ? 'default' : 'paper'}
    >
      <CardContent css={styles.content}>
        <Typography component="div" css={styles.labelContainer}>
          <Typography variant="caption">{title || formatMessage({ id: 'add' })}</Typography>
          <Typography variant="caption" color="textSecondary" css={styles.subTitle}>
            {subtitle || formatMessage({ id: 'favoritePlaces_address_add_label' })}
          </Typography>
        </Typography>
        <AddFullIcon css={styles.icon(theme)} />
      </CardContent>
    </BasicCardButton>
  )
}

export default AutocompleteAddFavorite
